import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { RelatedContentApiService } from './related-content-api-service';

export class RelatedContentDataSource extends ApiDataSource {
  protected Data: BehaviorSubject<[]> = new BehaviorSubject([]);
  constructor(
    protected Api: RelatedContentApiService,
    private readonly role: any,
    private listingId?: any
  ) {
    super();
  }

  protected loadData(PageEvent: PageEvent) {
    return this.Api.listWithPageEvent(
      this.role,
      this.listingId,
      this.filter.value,
      PageEvent
    );
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }

  public save(RelatedContent) {
    return this.Api.save(
      this.role,
      RelatedContent,
      this.listingId
    ).then((result) => {
      this.loadWithPageEvent();
      return result.data;
    });
  }
  public delete(RelatedContent, listingId) {
    return this.Api.delete(this.role, RelatedContent, listingId).then(
      (result) => {
        this.loadWithPageEvent();
        return result;
      }
    );
  }
}
